
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwell as ObiSwellElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-swell.js';
 
 
 

 
 export const ObiSwell = createComponent({
   react: React,
   tagName: 'obi-swell',
   elementClass: ObiSwellElement,
   events: {
     
   }
  });
 
 